import { useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useGetStarted = () => {
  const { api } = useContext(GlobalContext);

  const postRequest = useCallback(
    async (endpoint, body) => {
      if (!api) {
        throw new Error("API instance not found");
      }

      const response = await api.post(endpoint, body);

      return response?.data;
    },
    [api]
  );

  const registerUser = async (payload) => {
    try {
      return await postRequest(
        "/api/User/anlookRegistration",
        payload
      );
    } catch (error) {
      throw error?.response?.data || error;
    }
  };

  const verifyOTP = async (payload) => {
    try {
      return await postRequest(
        "/api/User/anlookRegistrationVerify",
        payload
      );
    } catch (error) {
      throw error?.response?.data || error;
    }
  };

  return {
    registerUser,
    verifyOTP,
  };
};

export default useGetStarted;